(function () {
  function initHero(root) {
    var slides = root.querySelectorAll('.hero-slide__slide');
    var dots = root.querySelectorAll('.hero-slide__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var speed = parseInt(root.getAttribute('data-autoplay'), 10) || 6;
    var timer = null;

    function setFilling(index) {
      dots.forEach(function (dot) {
        dot.classList.remove('is-filling');
      });
      // force reflow so the animation restarts cleanly
      void root.offsetWidth;
      if (dots[index]) {
        dots[index].style.setProperty('--hero-slide-duration', speed + 's');
        dots[index].classList.add('is-filling');
      }
    }

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (index + slides.length) % slides.length;
      var newSlide = slides[current];

      // Force a reflow so the fade-up animation restarts cleanly every time,
      // even if this same slide was active before (e.g. after a full loop)
      newSlide.classList.remove('is-active');
      void newSlide.offsetWidth;
      newSlide.classList.add('is-active');

      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }

      setFilling(current);
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      root.classList.remove('is-paused');
      setFilling(current);
      timer = setInterval(next, speed * 1000);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function pauseAutoplay() {
      stopAutoplay();
      root.classList.add('is-paused');
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        goTo(index);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', pauseAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Touch swipe support (mobile only — desktop has no touch events, so this never fires there)
    var touchStartX = 0;
    var touchEndX = 0;
    var SWIPE_THRESHOLD = 40;

    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      pauseAutoplay();
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;

      if (Math.abs(delta) > SWIPE_THRESHOLD) {
        if (delta < 0) {
          goTo(current + 1); // swiped left → next slide
        } else {
          goTo(current - 1); // swiped right → previous slide
        }
      }

      startAutoplay();
    }, { passive: true });

    startAutoplay();
  }

  document.querySelectorAll('.hero-slide').forEach(initHero);

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector('.hero-slide');
    if (hero) initHero(hero);
  });
})();
